
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { singularityStore, globalStore, configStore } from "@/store/store";
import { BorderRadius, BORDER_RADIUS_VALUES } from "@/types/singularity/brand";
import IconButtonShuffle from "../../components/IconButtonShuffle.vue";
import Icon from "@/components/UI/Icon.vue";
import TogglePanel from "../../components/TogglePanel.vue";
import { StyleValue } from "vue/types/jsx";
import {
  updateGlobalButtonStyles,
  updateGlobalFormStyles
} from "@/lib/singularity/brand/buttons-forms";

@Component({
  components: {
    IconButtonShuffle,
    Icon,
    TogglePanel
  }
})
export default class BrandManageColors extends Vue {
  get brand() {
    return singularityStore.brand;
  }

  get bodyFont() {
    const bodyFont = globalStore.globalSettings.settings.typography.body_font;
    return configStore.fonts.find(font => font.slug === bodyFont);
  }

  buttonRadiuses: BorderRadius[] = ["none", "sm", "md", "lg", "full"];
  inputRadiuses: BorderRadius[] = ["none", "sm", "md"];

  get buttonBorderRadius() {
    return singularityStore.brand.ui.buttonRadius;
  }

  get inputBorderRadius() {
    return singularityStore.brand.ui.inputRadius;
  }

  get sampleUIStyles() {
    if (!this.brand.color.neutral) {
      return {};
    }
    return {
      backgroundColor: this.brand.color.primary?.scale[100].value?.toString()
    };
  }

  get stylesPrimary() {
    if (!this.brand.color.primary) {
      return {} as StyleValue;
    }
    return {
      backgroundColor: this.brand.color.primary.base.value?.toString(),
      color: this.brand.color.primary.text.value?.toString(),
      borderRadius: BORDER_RADIUS_VALUES[this.buttonBorderRadius]?.style
      // fontFamily: this.bodyFont?.cssName || "sans-serif"
    } as StyleValue;
  }

  get stylesSecondary() {
    if (!this.brand.color.neutral) {
      return {} as StyleValue;
    }
    return {
      backgroundColor: "transparent",
      color: this.brand.color.neutral.base.value?.toString(),
      borderColor: this.brand.color.neutral.scale[300].value?.toString(),
      borderRadius: BORDER_RADIUS_VALUES[this.buttonBorderRadius]?.style
      // fontFamily: this.bodyFont?.cssName || "sans-serif"
    } as StyleValue;
  }

  get stylesLabel() {
    if (!this.brand.color.neutral) {
      return {} as StyleValue;
    }
    return {
      color: this.brand.color.neutral.base.value?.toString()
      // fontFamily: this.bodyFont?.cssName || "sans-serif"
    } as StyleValue;
  }

  get stylesForms() {
    if (!this.brand.color.neutral) {
      return {} as StyleValue;
    }
    return {
      borderColor: this.brand.color.neutral.scale[200].value?.toString(),
      borderRadius: BORDER_RADIUS_VALUES[this.inputBorderRadius]?.style,
      color: this.brand.color.neutral.scale[300].value?.toString()
    } as StyleValue;
  }

  shuffleButtonCorners() {
    const randomIndex = Math.floor(Math.random() * this.buttonRadiuses.length);
    singularityStore.setRadius({
      buttonRadius: this.buttonRadiuses[randomIndex]
    });
    updateGlobalButtonStyles();
  }

  shuffleInputCorners() {
    const randomIndex = Math.floor(Math.random() * this.inputRadiuses.length);
    singularityStore.setRadius({
      inputRadius: this.inputRadiuses[randomIndex]
    });
    updateGlobalFormStyles();
  }

  shuffle() {
    this.shuffleButtonCorners();
    this.shuffleInputCorners();
  }
}
